




































































import { Component, Vue } from 'vue-property-decorator';
import { TotalUsageSummary } from '@/api';

import StatTile from '@/components/common/StatTile.vue';
import DatePicker from '@/components/common/DatePicker.vue';

import dayjs from 'dayjs';

@Component({ components: { DatePicker, StatTile } })
export default class TotalUsageSummaryDashboard extends Vue {
  totalUsageSummary: TotalUsageSummary | null = null;

  cutoffDate: string | null = null;

  isLoading = false;

  async getUsageSummary() {
    if (!this.cutoffDate) {
      return;
    }

    this.isLoading = true;
    this.totalUsageSummary = null;

    this.totalUsageSummary = (
      await TotalUsageSummary.where({
        cutoff_date: this.cutoffDate,
      }).first()
    ).data;

    this.isLoading = false;
  }

  mounted() {
    this.cutoffDate = `${
      dayjs()
        .endOf('day')
        .toISOString()
        .split('.')[0]
    }Z`;
    this.getUsageSummary();
  }
}
